import React from 'react';
import { Box, Checkbox, Logo } from '@chargify/custom-ui-components';

import { PaymentProfile } from '../../../../models/paymentProfile';
import { ExpiredStatus } from '../ExpiredStatus';
import { Label } from './components';
import { Wrapper } from './PaymentProfileItem.styles';
import { useTranslation } from 'react-i18next';

type Props = {
  paymentProfile: PaymentProfile;
  onPaymentProfileSelected: (paymentProfileId: number) => void;
  isChecked: boolean;
};
export const PaymentProfileItem = ({
  paymentProfile,
  onPaymentProfileSelected,
  isChecked,
}: Props) => {
  const { creditCard } = paymentProfile;
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <Wrapper>
      <Checkbox
        onChange={() => onPaymentProfileSelected(paymentProfile.id)}
        value={isChecked}
        label={() =>
          Label({
            maskedNumber: creditCard.maskedNumber,
            expirationYear: creditCard.expirationYear,
            expirationMonth: creditCard.expirationMonth,
          })
        }
      />
      <Box display={'flex'}>
        {creditCard.expired ? (
          <ExpiredStatus text={t('payment_profile.expired')} />
        ) : null}
        <Logo type={creditCard.cardType} />
      </Box>
    </Wrapper>
  );
};
